import { createSelector } from "reselect";

const getData = (state) => state.lessons.data;
const getLessonEntities = (state) => state.entities.lessons;
const getEventEntities = (state) => state.entities.events;

/*****************
 *
 * EXPORT METHODS
 *
 *****************/

export const getLessons = (state) =>
    createSelector(getData, getLessonEntities, (data, lessons) => {
        return data
            .map((id) => lessons[id])
            .sort((a, b) => {
                let dateA = a.date.split("/").reverse().join("");
                let dateB = b.date.split("/").reverse().join("");
                return dateA > dateB ? 1 : dateA < dateB ? -1 : 0;
            });
    })(state);

export const getLessonDetails = (state, id) =>
    createSelector(getLessonEntities, (lessons) => {
        if (!lessons || !lessons[id]) return null;

        return lessons[id];
    })(state);

export const getEventDetails = (state, id) =>
    createSelector(getEventEntities, (events) => {
        if (!events || !events[id]) return null;

        return events[id];
    })(state);
